import { Image, Text, View } from "@react-pdf/renderer";
import { currResultsStyle } from "./CurriculumResultsContent";
import { AggregatedCapability } from "./AggregatedCapability";
import React from "react";
import { Curriculum, CurriculumResult } from "../../../../api/types";

interface CurrDetailsProps {
	curr: Curriculum;
	currResults: CurriculumResult[];
}

export const CurriculumDetails: React.FC<CurrDetailsProps> = ({
	curr,
	currResults,
}): JSX.Element => (
	<View
		style={{
			backgroundColor:
				parseFloat(getCurriculumEvaluation(curr, currResults)) >
				parseFloat("75.00%")
					? "#E9F0F1"
					: "rgba(233, 240, 241, 0.5)",
			borderRadius: 8,
			paddingTop: 8,
			width: 516,
			flexDirection: "row",
			marginBottom: 20,
		}}
	>
		<View style={currResultsStyle.curriculumDetailLeft}>
			<Text style={currResultsStyle.curriculumCode}>{curr.code}</Text>
			{parseFloat(getCurriculumEvaluation(curr, currResults)) >
				parseFloat("75.00%") && (
				<Image src="/images/TickBox.png" style={currResultsStyle.tickBox} />
			)}
		</View>
		<View style={currResultsStyle.curriculumDetailRight}>
			<Text style={currResultsStyle.codeDescription}>{curr.description}</Text>
			<View style={currResultsStyle.curriculumEntryContainer}>
				<View style={currResultsStyle.curriculumEntry}>
					<Text style={currResultsStyle.curriculumEntryName}>Year Level:</Text>
					<Text style={currResultsStyle.curriculumEntryContent}>
						{curr.yearLevel}
					</Text>
				</View>
				<View style={currResultsStyle.curriculumEntry}>
					<Text style={currResultsStyle.curriculumEntryName}>
						General Capability:
					</Text>
					<AggregatedCapability capabilities={curr.capabilityList} />
				</View>
			</View>
		</View>
	</View>
);

// TODO: The method of defining curriculum status will
//  need to be defined in future development
function getCurriculumEvaluation(
	curr: Curriculum,
	currResults: CurriculumResult[],
): string {
	const targetCurr: CurriculumResult | undefined = currResults.find(
		(res) => res.curriculumDetails.id === curr.id,
	);
	if (instanceOfCurriculumResult(targetCurr)) {
		return targetCurr.evaluation;
	} else {
		// should not enter this clause
		// just in case
		return "";
	}
}

function instanceOfCurriculumResult(object: any): object is CurriculumResult {
	return (
		"userId" in object &&
		"curriculumDetails" in object &&
		"evaluation" in object
	);
}
